'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import Bugsnag from '@bugsnag/js'

const bugsnagApiKey = process?.env?.NEXT_PUBLIC_BUGSNAG_CLIENT_KEY

if (bugsnagApiKey) {
  Bugsnag.start({
    apiKey: bugsnagApiKey,
    releaseStage: process.env.NODE_ENV,
    collectUserIp: false,
    enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'request'],
    trackInlineScripts: false,
    onSession: function (session) {
      session.setUser(null)
    },
  })
}

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    if (Bugsnag && process.env.NODE_ENV !== 'development') {
      Bugsnag.notify(error.digest)
    }
  }, [error])

  return (
    <div className="container flex flex-col items-center justify-center py-xxxl ms-up:h-[calc(100vh-262px)]">
      <h1 className="font-serif text-30 font-bold">
        An error has occurred while loading this page
      </h1>

      <p className="p">
        A copy of the error message has been sent to our support team. We will investigate and fix
        the issue as soon as possible.
      </p>

      <p className="p">
        In the meantime, you can{' '}
        <Link href="#" onClick={reset}>
          try again{' '}
        </Link>
        or <Link href="/">returning to the home page</Link>
      </p>
    </div>
  )
}
